<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
export default {
  data() {
    return {};
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <a href="/" class="logo-footer">
              <img src="images/cutill/icon-1024-lg-white.png" height="60" alt="" />
            </a>
            <p class="mt-4">
              L'outils d'encaissement à destination des coiffeurs indépendants, à domicile, des métiers de la beautés et du services.
            </p>
            <ul class="list-unstyled social-icon social mb-0 mt-4" v-if="false">
              <li class="list-inline-item">
                <a href="javascript:void(0)" class="rounded">
                  <facebook-icon class="fea icon-sm fea-social"></facebook-icon>
                </a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)" class="rounded">
                  <instagram-icon
                    class="fea icon-sm fea-social"
                  ></instagram-icon>
                </a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)" class="rounded">
                  <twitter-icon class="fea icon-sm fea-social"></twitter-icon>
                </a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)" class="rounded">
                  <linkedin-icon class="fea icon-sm fea-social"></linkedin-icon>
                </a>
              </li>
            </ul>
            <!--end icon-->
          </div>
          <!--end col-->

          <div class="col-lg-6 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">Liens utiles</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <router-link to="/mentions-legales" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Nos mentions légales</router-link
                >
              </li>
              <li>
                <router-link to="/conditions" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Nos conditions générales d'utilisations</router-link
                >
              </li>
              <li>
                <a href="/contact" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> Nous contacter
                </a>
              </li>
            </ul>
          </div>
          <!--end col-->
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
    <footer class="footer footer-bar">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-sm-6">
            <div class="text-sm-left">
              <p class="mb-0">
                © 2020 - {{ new Date().getFullYear() }} Cutill, fait avec
                <i class="mdi mdi-heart text-danger"></i> à Aix-en-Provence
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
  </div>
</template>
